import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	confluenceAfterUpgradeAIStandardModalTitle: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.title',
		defaultMessage: 'Welcome to Standard',
		description: 'Title welcoming user to their Standard Trial',
	},
	confluenceAfterUpgradeAIStandardModalSubtitle: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.subtitle',
		defaultMessage:
			'You successfully unlocked new ways to create, organize, and discover content with the help of AI',
		description: 'Subtitle explaining to user the value of AI in their Standard Trial',
	},
	confluenceAfterUpgradeAIStandardModalPrimaryCTA: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.primary-cta',
		defaultMessage: 'Get started',
		description: 'CTA text prompting user to start playing around with AI on their Standard Trial',
	},
	confluenceAfterUpgradeAIStandardModalSecondaryCTA: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.secondary-cta',
		defaultMessage: 'Close',
		description: 'CTA text prompting user to close the modal',
	},
	confluenceAfterUpgradeAIStandardModalAIDraft: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-draft',
		defaultMessage: 'Ask AI to draft pages and improve writing',
		description:
			'Text appearing in a list detailing AI features about drafting pages and improving writing',
	},
	confluenceAfterUpgradeAIStandardModalAISummaries: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-summaries',
		defaultMessage: 'Catch up on pages by generating a summary',
		description: 'Text appearing in a list detailing AI features about generating AI summaries',
	},
	confluenceAfterUpgradeAIStandardModalAIContextualInfo: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-contextual-info',
		defaultMessage: 'Find contextual and reliable information with AI',
		description: 'Text appearing in a list detailing AI features about finding info via AI',
	},
});
